const Style = {

  base: 'relative block text-sm mb-2 uppercase',
  required: `after:text-sg-red after:ml-1 after:font-semibold after:content-['*']`

}

export default Style;